import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getRoute, loading } from '../../../actions/sessions';
import { asyncActions } from '../../../actions/general';
import { getCreditLineAvailable } from '../../../actions/companies';
import { formatCurrency } from '../../../lib/formatters';
import { borrowerPortalUrl } from '../../../constants/SiteVariables';
import useRouteStatus from '../../../hooks/useRouteStatus';
import useSessionEntity from '../../../hooks/useSessionEntity';
import Error from '../../shared/Error';

export default function HasCreditChanges({location}) {
  const dispatch = useDispatch();

  const application = useSessionEntity('application');
  const company = useSessionEntity('company');

  const [tclAvailable, setTclAvailable ] = useState(0);
  const NextButton = () => {
    return (<button
              type="button"
              role="submit"
              className='mt-2 button is-large is-fullwidth is-info is-size-5 has-text-weight-semibold'
              onClick={nextScreen}>
              Next
            </button>)
  };

  const nextScreen = (e) => {
    e.preventDefault();

    dispatch(loading(true));
    dispatch(asyncActions(
      getRoute()
    ))
    .then(res => dispatch(loading(false)));
  };

  useEffect(() => {
    if (company) {
      dispatch(asyncActions(
        getCreditLineAvailable(company.id)
      ))
      .then(res => setTclAvailable(res.attributes.data));
    }
  }, [company, dispatch]);

  useRouteStatus(location);

  if (application.previous_tcl < company.credit_line.get('amount')) {
    return (
      <div role="main" id="content" className="has-text-centered">
        <h1 className="is-size-1">Good News!</h1>
        <h2>You’ve earned an increase in your Credit Key credit line.</h2>

        <Error />

        <p>
          Your credit limit of {formatCurrency(application.previous_tcl)} has been increased
          to <span className="text-green-highlight">{formatCurrency(company.credit_line.get('amount'))}</span>.
        </p>
        <p>You currently have {formatCurrency(tclAvailable)} available to spend.</p>
        <NextButton />
      </div>
    )
  } else {
    return (
      <div role="main" id="content" className="has-text-centered">
        <h1 className="is-size-1">Change of Credit</h1>
        <p>
          There’s been an update to your business line of credit.
          Your credit limit of {formatCurrency(application.previous_tcl)} has been decreased
          to {formatCurrency(company.credit_line.get('amount'))}.
        </p>

        <Error />

        {tclAvailable >= 0 ?
          <p>You currently have {formatCurrency(tclAvailable)} remaining.</p>
          :
          <p>
            <strong>You are currently over your limit.</strong> Please log into
            your <a href={borrowerPortalUrl()} target="_blank">dashboard</a> to make a payment at your
            earliest convenience.
          </p>}
        <NextButton />
      </div>
    )
  }
}
